import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material';
import { SkillTalentLevel } from '@bloomays-lib/types.shared';
import TalentSectionContainer from './TalentSectionContainer';
import { InformationMessage } from '../atoms/InformationMessage';
import ItemTalentLevelList from '../molecules/ItemTalentLevelList';

export type TalentSkillsSectionProps = {
  skills: SkillTalentLevel[];
  addActionFn?: () => void;
};

const TalentSkillsSection = ({ skills, addActionFn }: TalentSkillsSectionProps) => {
  const { t } = useTranslation(['talentSheet']);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <TalentSectionContainer
      title={t('skills')}
      emptyText={t('noSkills')}
      addActionFn={addActionFn}
      addActionText={t('addSkill', { ns: 'talentSheet' })}
    >
      {skills.length > 0 && (
        <ContentWrapper>
          {!isMobile && <InformationMessage text={t('explainCalcul', { ns: 'talentSheet' })} />}
          <ItemTalentLevelList items={skills} />
        </ContentWrapper>
      )}
    </TalentSectionContainer>
  ) as React.ReactNode;
};

export { TalentSkillsSection };
export default TalentSkillsSection;

const ContentWrapper = styled('div')(() => ({
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
}));
